import React, { useEffect, useRef, useState } from "react";
import { IoMdArrowDropright, IoMdArrowDropleft } from "react-icons/io";
const WEEK_DAYS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];

const WEEK_MAP = {
    Dom: 0,
    Seg: 1,
    Ter: 2,
    Qua: 3,
    Qui: 4,
    Sex: 5,
    Sab: 6,
};

const Calendar = ({ allowedDays = [], selectedDate, setSelectedDate, disablePastDates = false }) => {
    const [open, setOpen] = useState(false);
    const [currentDate, setCurrentDate] = useState(new Date());
    const ref = useRef(null);

    const allowedWeekDays = allowedDays.map(d => WEEK_MAP[d]);

    const daysInMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0
    ).getDate();

    const firstDayOfMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
    ).getDay();

    const handleSelect = (day) => {
        const date = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            day
        );

        if (!allowedWeekDays.includes(date.getDay())) return;
        if (isPastDate(date)) return;

        setSelectedDate(date);
        setOpen(false);
    };


    // fechar ao clicar fora
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const isPastDate = (date) => {
        if (!disablePastDates) return false;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const compareDate = new Date(date);
        compareDate.setHours(0, 0, 0, 0);

        return compareDate < today;
    };

    const getDate = (date) => {
        const formated = new Date(date)
        if (formated == 'Invalid Date') {
            return ''
        }
        return formated.toLocaleDateString()
    }

    return (
        <div ref={ref} style={{ position: "relative" }}>
            {/* INPUT */}
            <input
                readOnly
                onClick={() => setOpen(!open)}
                value={getDate(selectedDate)}
                placeholder="Selecione a data"
                style={{
                    width: "100%",
                    padding: 10,
                    borderRadius: 6,
                    border: "1px solid #d1d5db",
                    cursor: "pointer",
                }}
            />

            {/* POPUP */}
            {open && (
                <div
                    style={{
                        position: "absolute",
                        top: "110%",
                        left: 0,
                        background: "#fff",
                        border: "1px solid #e5e7eb",
                        borderRadius: 8,
                        padding: 10,
                        zIndex: 10,
                        boxShadow: "0 10px 25px rgba(0,0,0,.1)",
                    }}
                >
                    {/* HEADER */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: 8,
                        }}
                    >
                        <button
                            onClick={() =>
                                setCurrentDate(
                                    new Date(
                                        currentDate.getFullYear(),
                                        currentDate.getMonth() - 1,
                                        1
                                    )
                                )
                            }
                        >
                            <IoMdArrowDropleft />
                        </button>
                        <strong>
                            {currentDate.toLocaleString("pt-BR", {
                                month: "long",
                                year: "numeric",
                            })}
                        </strong>
                        <button
                            onClick={() =>
                                setCurrentDate(
                                    new Date(
                                        currentDate.getFullYear(),
                                        currentDate.getMonth() + 1,
                                        1
                                    )
                                )
                            }
                        >
                            <IoMdArrowDropright />
                        </button>
                    </div>

                    {/* DIAS DA SEMANA */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(7, 1fr)",
                            textAlign: "center",
                            fontSize: 12,
                            marginBottom: 4,
                            fontWeight: 600,
                        }}
                    >
                        {WEEK_DAYS.map(day => (
                            <div key={day}>{day}</div>
                        ))}
                    </div>

                    {/* CALENDÁRIO */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(7, 1fr)",
                            gap: 4,
                        }}
                    >
                        {Array.from({ length: firstDayOfMonth }).map((_, i) => (
                            <div key={`empty-${i}`} />
                        ))}

                        {Array.from({ length: daysInMonth }).map((_, i) => {
                            const day = i + 1;
                            const date = new Date(
                                currentDate.getFullYear(),
                                currentDate.getMonth(),
                                day
                            );
                            const allowedWeekDay = allowedWeekDays.includes(date.getDay());
                            const pastDate = isPastDate(date);
                            const disabled = !allowedWeekDay || pastDate;

                            return (
                                <button
                                    key={day}
                                    onClick={() => handleSelect(day)}
                                    disabled={disabled}
                                    style={{
                                        padding: 6,
                                        borderRadius: 6,
                                        border: "none",
                                        background: disabled ? "#e5e7eb" : "#4f46e5",
                                        color: disabled ? "#9ca3af" : "#fff",
                                        cursor: disabled ? "not-allowed" : "pointer",
                                        opacity: pastDate ? 0.5 : 1,
                                    }}
                                >
                                    {day}
                                </button>

                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Calendar;
